import React from 'react';
import { Modal, Button } from 'react-bootstrap';


const TableColumnOrder = (props) => {
    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <h4>Customize according to you</h4>
                <div className="outerdiv">
                    <div className="innerdiv">
                        <input type="checkbox" className="column_check" {...props.getToggleHideAllColumnsProps()} />
                        Show All
                    </div>
                </div>
                {
                    props.allColumns.map((column) => (
                        <div key={column.Header} className="outerdiv">
                            <div className="innerdiv">
                                <input type="checkbox" className="column_check" {...column.getToggleHiddenProps()}></input>
                                {column.Header}
                            </div>
                        </div>
                    ))
                }
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-pill" onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default TableColumnOrder;